var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Mobile/PlansAndPricingMenu.js",
  _this = this;
import React from 'react';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import Menu from './components/Menu';
import { plansPricingMenu } from '../../config/linkInfo.js';
export var PlansAndPricingMenu = function PlansAndPricingMenu() {
  var handleMenuClick = function handleMenuClick() {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'review session landing page clicked pricingcta',
        interactionType: 'click'
      }
    });
  };
  return /*#__PURE__*/React.createElement(Menu, Object.assign({}, plansPricingMenu(), {
    onClick: handleMenuClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 10
    }
  }));
};
export default PlansAndPricingMenu;
//# sourceMappingURL=PlansAndPricingMenu.js.map